import { render, staticRenderFns } from "./CampaignItemPaymentStatusView.vue?vue&type=template&id=3bedb02a&"
import script from "./CampaignItemPaymentStatusView.vue?vue&type=script&lang=ts&"
export * from "./CampaignItemPaymentStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports